
(function() {
  // Add custom code below this line
  if(document.querySelectorAll('[data-carton-quantity]')){
    let allCartonQty = document.querySelectorAll('[data-carton-quantity]');
    let qtyBtn = document.querySelectorAll('.quantity--carton');
    for (let i = 0; i < allCartonQty.length; i++) {
      allCartonQty[i].addEventListener('input', function(){
        let val = parseInt(this.value);
        let target = this.getAttribute('data-target-qty');
        let target_element = document.querySelector('.'+target);
        let target_val = parseInt(document.querySelector('.'+target).getAttribute('min'));
        document.querySelector('.'+target).value = val * target_val;
        if(target_element.classList.contains('cart-page-qty')){
          target_element.dispatchEvent(new Event("change"));
        }
      });
    }
    
    for (let i = 0; i < qtyBtn.length; i++) {
      qtyBtn[i].addEventListener('click', function(){ 
         let initVal = parseInt(this.parentElement.querySelector('[data-carton-quantity]').value);
         let initMin = parseInt(this.parentElement.querySelector('[data-carton-quantity]').getAttribute('min'));
         if(this.classList.contains('quantity--minus')){
            if(initVal > initMin){
              this.parentElement.querySelector('[data-carton-quantity]').value = initVal - 1;
            }
         }else{
           this.parentElement.querySelector('[data-carton-quantity]').value = initVal + 1;
         }
          let target = this.parentElement.querySelector('[data-carton-quantity]').getAttribute('data-target-qty');
          let target_element = document.querySelector('.'+target);
          let target_val = parseInt(document.querySelector('.'+target).getAttribute('min'));
          document.querySelector('.'+target).value = parseInt(this.parentElement.querySelector('[data-carton-quantity]').value) * target_val;
          if(target_element.classList.contains('cart-page-qty')){
            target_element.dispatchEvent(new Event("change"));
          }
          
      });
    }
  }
  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();